export default __webpack_public_path__ + "static/media/queshengye-kaoshi.b77be64b.png";